import { useQuery } from '@tanstack/react-query';
import { GET_PROJECTS_LIST_KPIS } from '../../../query/project/stats/keys';
import {
  getProjectsListKpis,
  ProjectListKpi,
} from '../../../services/project/stats/ProjectDailyStatsService';

export const useProjectsListKpis = (
  ids: number[],
  from: Date,
  to: Date,
  /** Agency Hub: the visibility trend vs the preceding window (one more query per project server-side). */
  withVisibilityTrend = false
): { kpis: Record<number, ProjectListKpi>; isLoading: boolean } => {
  const enabled = ids.length > 0;

  const { data, isLoading } = useQuery<Record<number, ProjectListKpi>>({
    queryKey: [GET_PROJECTS_LIST_KPIS, ids, from, to, withVisibilityTrend],
    queryFn: () => getProjectsListKpis(ids, from, to, withVisibilityTrend),
    enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
  });

  return {
    kpis: data ?? {},
    isLoading: enabled ? isLoading : false,
  };
};
